export enum JournalType {
  Cash = 0,
  MiscellaneousOperations = 1,
  Sales = 2,
  All = 3,
  Taxes = 4,
  AccountStatement = 5,
}
